import { mapGetters, mapActions } from 'vuex'
import { isArray, isEmpty, trim, getByteLen, clearTagOfData } from '@/common/js/utils'
// 公共组件
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Moduler from '@/components/moduler'
import ErrorPop from '@/components/error-pop'
import InputLen from '@/components/input/input-len'
import AutoComplete from '@/components/autocomplete/autocomplete'
import Affix from '@/components/affix.vue'

import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import brandDataAll from '@/data/toutiao/brand_all_categroy'
import cityData from '@/data/toutiao/city_province'
import weektimeData from '@/data/toutiao/weektime_data'
import tagsData from '@/data/toutiao/ad_tag'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'

const DATA = { articleData, brandData, brandDataAll, cityData, weektimeData, tagsData, gategoryData, autotendData }

export default {
  components: { Mixcheck, CheckItem, RadioItem, Moduler, ErrorPop, InputLen, AutoComplete, Affix },
  computed: {
    ...mapGetters('Toutiaonewlocal', ['subCurrent', 'subModules'])
  },
  methods: {
    ...mapActions('Toutiaonewlocal', ['refreshDocTitle']),
    invalid(rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? this[rule.name.split('/')[0]][rule.name.split('/')[1]] : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string') {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else {
          param = ruleName
          length = String(param).length
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? this[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if ((rule.require && !param) || (rule.require && isEmpty(param))) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (param && rule.max < length) {
          const msg = `${rule.desc}不能多于${rule.max}个字符`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }
        if (param && rule.min > length) {
          const msg = `${rule.desc}不能少于${rule.min}个字符`
          this.formErr = true
          arr.push({ feild: rule.desc, msg: rule.msg || msg })
          continue
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    inputTrim(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = Number(parseFloat(val).toFixed(2))
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    inputTrimFour(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = Number(parseFloat(val).toFixed(4))
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    // 不限时还原默认值 - 地区组件\时间段组件
    radioChange(defautData) {
      clearTagOfData(DATA[defautData], this)
      this[defautData] = JSON.parse(JSON.stringify(DATA[defautData]))
    },
    // 多选卡还原默认值
    multRadioChange(val, mult) {
      if (val === 'NONE') this.formItem[mult] = JSON.parse(JSON.stringify([]))
    },
    beforeHandler() {
      window.onbeforeunload = function (event) {
        const msg = '您正在编辑内容，离开数据将丢失，确定要退出本页吗？'
        event.returnValue = msg
        return msg
      }
    },
    toTop() {
      const contentElem = window.document.querySelector('.ivu-layout-content')
      contentElem.scrollTop = 0
      contentElem.addEventListener('scroll', this.handleScroll)
    },
    handleScroll(e) {
      this.$store.commit('Toutiaonewlocal/setScroll', e.target.scrollTop)
    }
  },
  data() {
    return {
      loading: null,
      saving: null,
      formErr: null,
      errRes: [],
      account: this.$store.state.Toutiaonewlocal.accountId,
      media: 10,
      opId: Number(this.$store.state.Toutiaonewlocal.account)
    }
  },
  mounted() {
    this.$nextTick(() => {
      // this.beforeHandler()
      this.toTop()
      this.refreshDocTitle()
    })
  },
  beforeDestroy() {
    const contentElem = window.document.querySelector('.module-content')
    contentElem.removeEventListener('scroll', this.handleScroll)
  }
}
